import React from 'react';

const AlertNotification = ({ show, message, type, errorDetails, onClose }) => {
  if (!show) return null;

  return (
    <div className="fixed top-6 right-6 z-50 animate-slide-in-from-right max-w-md">
      <div className={`bg-white rounded-xl shadow-2xl border-l-4 p-4 ${
        type === 'success' ? 'border-green-500' : 
        type === 'warning' ? 'border-yellow-500' : 
        'border-red-500'
      }`}>
        <div className="flex items-start gap-3">
          <div className={`flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center ${
            type === 'success' ? 'bg-green-100 text-green-600' : 
            type === 'warning' ? 'bg-yellow-100 text-yellow-600' : 
            'bg-red-100 text-red-600'
          }`}>
            {type === 'success' ? '✓' : 
             type === 'warning' ? '⚠' : 
             '✕'}
          </div>
          
          <div className="flex-1">
            <p className="text-sm font-semibold text-gray-900">{message}</p>
            
            {errorDetails?.suggestions && errorDetails.suggestions.length > 0 && (
              <div className="mt-2 space-y-1">
                <p className="text-xs font-medium text-gray-700">Suggestions:</p>
                <ul className="text-xs text-gray-600 space-y-1">
                  {errorDetails.suggestions.map((suggestion, index) => (
                    <li key={index} className="flex items-start gap-1">
                      <span className="text-blue-500 mt-0.5">•</span>
                      <span>{suggestion}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
          
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 ml-2"
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertNotification;
